// extracted by mini-css-extract-plugin
export var autoExpand = "_20-b";
export var container = "_20-a";
export var containerWidth = "_20-8";
export var disabled = "_20-2";
export var error = "_20-3";
export var fullWidth = "_20-9";
export var highlightContainer = "_20-5";
export var inputWrapper = "_20-0";
export var small = "_20-1";
export var textarea = "_20-4";
export var validatedTextarea = "_20-6";
export var visuallyHidden = "_20-7";